import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { columnWidth, size, spacing } from '../../styles/tokens.stylex';
export const maxColumnGridTokens = {
  maxColumns: "var(--xzp9k29)",
  gridGap: "var(--xyd4udo)",
  gridColMinSize: "var(--x1mgqjin)",
  gridColSizeCalc: "var(--xlf67dp)",
  gridColMinSizeCalc: "var(--xtpmlzj)",
  __varGroupHash__: "x175wp4p"
};